import { formatCurrency } from "@/lib/format";

export function TakeHomeValue({
  value,
  compact = false,
}: {
  value: number | null | undefined;
  compact?: boolean;
}) {
  if (value === null || value === undefined) {
    return <span className="text-[var(--color-text-tertiary)] tabular-nums">Not projected</span>;
  }

  const isNegative = value < 0;
  return (
    <span
      className="tabular-nums font-medium"
      style={{ color: isNegative ? "var(--color-negative)" : "var(--color-positive)" }}
    >
      {formatCurrency(value, { compact })}
    </span>
  );
}
